import type {
  ConnectionTestResult,
  Paginated,
  ShopifyProductSearchResponse,
  StoreDetail,
  StoreListItem,
  StoreUpdateBody,
} from '@flux/shared';
import { apiFetch } from '@/lib/api/client.js';

/** Onglet Boutiques (`02` §12.2) — API `/api/stores`, distincte de `/api/settings`. */
export function fetchStoresList(): Promise<Paginated<StoreListItem>> {
  return apiFetch<Paginated<StoreListItem>>('/api/stores', { query: { page: 1, pageSize: 200 } });
}

export function fetchStoreDetail(code: string): Promise<StoreDetail> {
  return apiFetch<StoreDetail>(`/api/stores/${encodeURIComponent(code)}`);
}

export function updateStore(code: string, body: StoreUpdateBody): Promise<StoreDetail> {
  return apiFetch<StoreDetail>(`/api/stores/${encodeURIComponent(code)}`, { method: 'PUT', body });
}

export function searchStoreProducts(code: string, query: string): Promise<ShopifyProductSearchResponse> {
  return apiFetch<ShopifyProductSearchResponse>(`/api/stores/${encodeURIComponent(code)}/products/search`, {
    query: { query },
  });
}

export function testStoreConnection(code: string): Promise<ConnectionTestResult> {
  return apiFetch<ConnectionTestResult>(`/api/stores/${encodeURIComponent(code)}/test-connection`, {
    method: 'POST',
  });
}

/**
 * `GET /auth/shopify/install` redirige côté serveur (cookie de session, pas
 * de JSON) — jamais un appel `apiFetch`/`Link`, toujours une ancre brute
 * (`<a href={installUrl(code)}>`, voir `store-detail-form.tsx`).
 */
export function installUrl(code: string): string {
  return `/auth/shopify/install?store=${encodeURIComponent(code)}`;
}

/**
 * Première installation : la boutique n'existe pas encore, elle sera **créée**
 * au retour du callback OAuth à partir de ce qu'en dit Shopify (`04` §4.3,
 * décision du 10/09/2026 — plus d'ajout manuel).
 */
export function installUrlForShop(shopDomain: string): string {
  return `/auth/shopify/install?shop=${encodeURIComponent(shopDomain.trim().toLowerCase())}`;
}
